import { Component, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AddStyleTemplateRequest, AddStyleTemplateResponse, ListTagsRequest, ListTagsResponse, SituViewWebApiClient, Tag } from "situview-webapi-client";
import { AuthService, HomeService, StateService, TaggingService } from "src/app/services";
import { SituBaseComponent } from "src/app/shared/situ-base-component";

@Component({
  selector: 'style-template-copy-dialog',
  templateUrl: './style-template-copy-dialog.component.html',
  styleUrls: ['./style-template-copy-dialog.component.scss']
})
export class StyleTemplateCopyDialogComponent extends SituBaseComponent {
  mode: string = 'global';

  allBrandTags: Tag[] = [];

  selectedTag: Tag | undefined;
  renameForm: FormGroup;
  
  constructor(
    authService: AuthService,
    stateService: StateService,
    public dialogRef: MatDialogRef<StyleTemplateCopyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IStyleTemplateCopyDialogData,
    private homeService: HomeService,
    private situViewClient: SituViewWebApiClient,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private router: Router) {
      super(authService, stateService);
      this.renameForm = this.fb.group({
        newName: [this.data.existingName, [Validators.required]]
      });
    }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadTags();
  }

  notSameAsExisting(control: FormControl) {
    return control.value !== this.data.existingName ? null : { sameAsExisting: true };
  }

  onRename() {
    if (this.renameForm.valid) {
      this.dialogRef.close(this.renameForm.value.newName);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  setMode(mode: string) {
    if (mode && mode !== this.mode) this.mode = mode;
  }

  addTemplate() {
    let request = new AddStyleTemplateRequest();
    request.name = this.renameForm.value.newName;
    request.companyId = this.selectedCompany?.id;
    request.styles = this.data.styles;
    switch(this.mode) {
      case 'home':
      case 'tag':
        request.tagId = this.selectedTag?.id;
        request.homeId = undefined;
        break;
      default: 
        break;
    }

    this.situViewClient.addStyleTemplate(request)
      .then((response: AddStyleTemplateResponse) => {
        if (response.success) {
          this.snackBar.open(`Added Style Template!`, 'OK', { duration: 2000 });
          this.dialogRef.close();
          this.router.navigate([`admin/style-template`]);
          return;
        } else if (response?.errorMessages && response.errorMessages.length > 0) {
          this.snackBar.open(response.errorMessages[0], 'OK', { duration: 2000 });
        }
      })
      .catch((error: any) => {
        this.snackBar.open(`Error adding Style Template!`, 'OK', { duration: 2000 });
      });
  }

  private loadTags() {
    let request = new ListTagsRequest();
    request.companyId = this.selectedCompany?.id;

    this.situViewClient.listTags(request)
      .then((response: ListTagsResponse) => {
        if (response.success) {
          this.allBrandTags = response.tags?.filter(x => x.category?.name?.toLowerCase() === "brand")
              .reduce<Tag[]>((acc, current) => {
                  console.log("Current tag name:", current.name);
                  const x = acc.find(item => {
                      console.log("Comparing with:", item.name);
                      return item.name === current.name;
                  });
                  if (!x) {
                      console.log("Adding:", current.name);
                      return acc.concat([current]);
                  } else {
                      console.log("Skipping:", current.name);
                      return acc;
                  }
              }, []) ?? [];
        }
      });
  }
}

export interface IStyleTemplateCopyDialogData {
  existingName: string;
  styles: string[];
}